import moment from 'moment'

export default class DateHelper {
  static transformDateToFormat (date, format) {
    return moment(date).format(format)
  }
}
